import type { CashConfigProvenance } from './cash-locations.dto.js';

export const cashOperationValues = [
  'drawer_open',
  'drawer_close',
  'drawer_drop_to_vault',
  'drawer_refill',
  'cashier_self_refill',
  'drawer_to_drawer_transfer',
  'vault_intake',
  'vault_count',
  'drawer_expense',
  'drawer_expense_void',
  'vault_expense',
  'vault_expense_void',
  'treasury_funding',
  'treasury_count',
  'treasury_count_cancel',
  'treasury_delivery_instruction_issue',
  'treasury_delivery_instruction_cancel',
  'treasury_expense',
  'treasury_expense_void',
  'cash_needed_request_create',
  'cash_needed_request_cancel',
  'variance_recovery_submit',
  'variance_recovery_reject',
  'variance_recovery_approve',
  'variance_writeoff_apply',
  'variance_offset_apply',
  'variance_overage_classify',
  'variance_overage_remove',
] as const;

export type CashOperation = (typeof cashOperationValues)[number];

const cashOperationValueSet = new Set<string>(cashOperationValues);

export function isCashOperation(operation: string): operation is CashOperation {
  return cashOperationValueSet.has(operation);
}

export const cashPrerequisiteKindValues = [
  'cash_location',
  'cash_expense_category',
  'cash_session',
  'cash_variance_case',
  'cash_variance_action',
  'cash_expense',
  'cash_transfer',
  'cash_company_readiness',
] as const;

export type CashPrerequisiteKind = (typeof cashPrerequisiteKindValues)[number];

export const cashPrerequisiteReasonValues = [
  'missing',
  'inactive',
  'not_authoritative',
  'invalid_reference',
] as const;

export type CashPrerequisiteReason = (typeof cashPrerequisiteReasonValues)[number];

export interface CashPrerequisiteBlockerDto {
  kind: CashPrerequisiteKind;
  reason: CashPrerequisiteReason;
  entityId: string | null;
  message: string;
  canRemediate: boolean;
  requiredProvenance?: CashConfigProvenance;
}

export interface CheckCashPrerequisitesRequest {
  companyId: string;
  operation: CashOperation;
  storeId?: string;
  locationId?: string;
  stationId?: string;
  cashLocationId?: string;
  relatedCashLocationId?: string;
  cashSessionId?: string;
  caseId?: string;
  relatedCaseId?: string;
  actionId?: string;
  expenseId?: string;
  transferId?: string;
  categoryId?: string | null;
}

export interface CheckCashPrerequisitesResponse {
  operation: CashOperation;
  ready: boolean;
  blockers: CashPrerequisiteBlockerDto[];
  warnings: string[];
}
